define(function(require) {
    return  {
        COHORTE_2018: {
            ID: "2018",
            TITLE: "Cohorte 2018",
            THEMES_TEXT: "2018",
            UPDATE_THEMES: true,
        }, 
        COHORTE_2017: {
            ID: "2017",
            TITLE: "Cohorte 2017",
            THEMES_TEXT: "2017",
            UPDATE_THEMES: true,
        }, 
        COHORTE_2016: {
            ID: "2016",
            TITLE: "Cohorte 2016",
            THEMES_TEXT: "2016",
            UPDATE_THEMES: true,
        }, 
        COHORTE_2015: {
            ID: "2015",
            TITLE: "Cohorte 2015",
            THEMES_TEXT: "2015",
           UPDATE_THEMES: true,
        }, 
        COHORTE_2014: {
            ID: "2014",
            TITLE: "Cohorte 2014",
            THEMES_TEXT: "2014",
           UPDATE_THEMES: true,
        }, 
        COHORTE_2013: {
            ID: "2013",
            TITLE: "Cohorte 2013",
            THEMES_TEXT: "2013",
           UPDATE_THEMES: true,
        }, 
        COHORTE_2012: {
            ID: "2012",
            TITLE: "Cohorte 2012",
            THEMES_TEXT: "2012",
           UPDATE_THEMES: true,
        }, 
        COHORTE_2011: {
            ID: "2011",
            TITLE: "Cohorte 2011",
            THEMES_TEXT: "2011",
           UPDATE_THEMES: true,
        }, 
        COHORTE_2010: {
            ID: "2010",
            TITLE: "Cohorte 2010",
            THEMES_TEXT: "2010",
           UPDATE_THEMES: true,
        }, 
        COHORTE_2009: {
            ID: "2009",
            TITLE: "Cohorte 2009",
            THEMES_TEXT: "2009",
           UPDATE_THEMES: true,
        },  
        COHORTE_2008: {
            ID: "2008",
            TITLE: "Cohorte 2008",
            THEMES_TEXT: "2008",
           UPDATE_THEMES: true,
        }, 
        // COHORTE_2007: {
        //     ID: "2007",
        //     TITLE: "Cohorte 2007",
        //     UPDATE_THEMES: true,
        // }, 
        // COHORTE_2006: {
        //     ID: "2006",
        //     TITLE: "Cohorte 2006",
        //     UPDATE_THEMES: true,
        // }, 
        // COHORTE_2005: {
        //     ID: "2005",
        //     TITLE: "Cohorte 2005",
        //     UPDATE_THEMES: true,
        // }, 
        // COHORTE_2004: {
        //     ID: "2004",
        //     TITLE: "Cohorte 2004",
        //     UPDATE_THEMES: true,
        // }, 
        // COHORTE_2003: {
        //     ID: "2003",
        //     TITLE: "Cohorte 2003",
        //     UPDATE_THEMES: true,
        // }, 
        // COHORTE_2002: {
        //     ID: "2002",
        //     TITLE: "Cohorte 2002",
        //     UPDATE_THEMES: true,
        // }, 
        // COHORTE_2001: {
        //     ID: "2001",
        //     TITLE: "Cohorte 2001",
        //     UPDATE_THEMES: true,
        // }, 
        // COHORTE_2000: {
        //     ID: "2000",
        //     TITLE: "Cohorte 2000",
        //     UPDATE_THEMES: true,
        // }, 
        // COHORTE_1999: {
        //     ID: "1999",
        //     TITLE: "Cohorte 1999",
        //     UPDATE_THEMES: true,
        // }, 
        // COHORTE_1998: {
        //     ID: "1998",
        //     TITLE: "Cohorte 1998",
        //     UPDATE_THEMES: true,
        // },
    };
});
